import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50" role="contentinfo">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">{siteInfo.logo}</span>
              <span className="text-xl font-heading font-bold whitespace-nowrap">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">{siteInfo.description}</p>
            <div className="flex items-center gap-3">
              <a href={`mailto:${siteInfo.contact.email}`} className="w-9 h-9 rounded-lg border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-primary-500 hover:bg-primary-500 transition-all duration-200" aria-label="发送邮件">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-primary-500 hover:bg-primary-500 transition-all duration-200" aria-label="微信公众号">
                <i className="ri-wechat-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg border border-foreground-700 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-primary-500 hover:bg-primary-500 transition-all duration-200" aria-label="新浪微博">
                <i className="ri-weibo-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  联系方式
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  常见问题
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                  用户协议
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; {currentYear} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-600 whitespace-nowrap">
            网红吃瓜新闻聚合平台 | 每日更新热门爆料
          </p>
        </div>
      </div>
    </footer>
  );
}